import React, { useState, useEffect, useContext, useMemo } from 'react';

import SimpleTable from '../components/tables/simpleTable';

import RecoverModal from '../components/modals/recoverModal';
import DeleteModal from '../components/modals/deleteModal';
import ViewModal from '../components/modals/viewModal';
import VoidModal from '../components/modals/voidModal';

import SearchFilter from '../components/filters/search';
import CustomButton from '../components/buttons/customButton';
import IsActiveFilter from '../components/filters/isActive';
import AddButton from '../components/buttons/addButton';
import DataFilter from '../components/filters/dataFilter';
import DatePicker from '../components/filters/datePicker';
import { selectStyles } from '../components/dropDown/selectStyle';

import JvForm from './jvForm';

import { FcKindle } from "react-icons/fc";

import Loader from '../components/loader/loader';
import { numberFormatter } from '../components/formatters/numberFormatter';
import { dateFormatter } from '../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter, statusTextFormatter } from '../components/formatters/defFormatter';
import { dateTableFormatter } from '../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules, FcViewDetails } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../init/getData';

import TrashModal from '../components/modals/trashModal';

function DailyEntry(props) {
  const { api, userData, settingData, companyId, yearId, refData, branchOptions, allUserOptions,
    mainCurrency, secondaryCurrency, contentLanguages, branchId } = useContext(DataContext);

  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;

  const table = 'journalVoucher';
  const title = 'journalVoucher';

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '', companyId, yearId, fromDate: today, toDate: today });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedTypes, setSelectedTypes] = useState([]);

  const TypesData = [

    
    
    // Sales related
    { label: 'PosSale', value: ['PosSale'] },
    { label: 'SalesInvoice', value: ['SalesInvoice'] },
    { label: 'PosReturn', value: ['PosReturn'] },
    { label: 'SalesOrder', value: ['SalesOrder'] },
    { label: 'SalesReturn', value: ['SalesReturn'] },
    { label: 'PosOrder', value: ['PosOrder'] },
    
    // Purchases related 
    { label: 'PurchaseInvoice', value: ['PurchaseInvoice'] },
    { label: 'PurchaseReturn', value: ['PurchaseReturn'] },
    
    // Expenses related
    { label: 'ExpenseInvoice', value: ['ExpenseInvoice'] },
    { label: 'Salary', value: ['Salary'] },
    
    // Cash related
    { label: 'Payment', value: ['Payment'] },
    { label: 'Receipt', value: ['Receipt'] },
    
    // Stock related
    { label: 'StockControl', value: ['StockControl'] },
    { label: 'StockTransfer', value: ['StockTransfer'] },
    
  ];

  const selectedBranch = useMemo(() => {
    if (!userRole.viewAllBranches) {
      setFilter((prev) => ({ ...prev, branchId: branchId }));
      return branchOptions?.find(option => option.value === branchId);
    }
    return branchOptions?.find(option => option.value === filter.branchId);
  }, [userRole.viewAllUsers, filter.branchId]);

  const selectedUser = useMemo(() => {
    if (!userRole.viewAllUsers) {
      setFilter((prev) => ({ ...prev, createdBy: createdBy }));
      return allUserOptions?.find(option => option.value === createdBy);
    }
    return allUserOptions?.find(option => option.value === filter.createdBy);
  }, [allUserOptions, filter.createdBy]);

  // Handle type select change for multiple selection
  const handleTypeChange = (selectedOptions) => {
    setSelectedTypes(selectedOptions || []);
    
    // Flatten all selected values into a single array
    const allSelectedTypes = selectedOptions ? 
        selectedOptions.flatMap(option => option.value) : [];
    
    setFilter((prev) => ({
      ...prev,
      type: allSelectedTypes,
    }));
  };

  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {
    const transformedData = data.map(item => {
      return {
        Number: item.myIndex,
        SID: item.id,
        ID: item.myId,
        createdAt: item.createdAt,
        date: item.createdAt,
        account: item.account?.english || item.account?.name,
        type: item.type,
        [mainCurrency?.code]: numberFormatter(item.totalDebit),
        [secondaryCurrency?.code]: numberFormatter(item.secondaryTotalDebit),
        paymentType: item.paymentType,
        Status: statusTextFormatter(item.status),
        details: item.details
      };
    });

    return { transformedData };
  };

  const columnDefs = useMemo(() => [
    { title: contentLanguages.SID, dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.ID, dataIndex: 'myId', width: '4%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.CreatedAt, dataIndex: 'createdAt', render: dateTableFormatter },
    { title: contentLanguages.Date, dataIndex: 'date', width: '8%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.Type, dataIndex: 'type', width: '10%' },
    { title: mainCurrency?.code, dataIndex: 'totalDebit', render: numberFormatter },
    { title: secondaryCurrency?.code, dataIndex: 'secondaryTotalDebit', render: numberFormatter },
    { title: contentLanguages.Payment, dataIndex: 'paymentType', render: paymentTypeFormatter },
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
    { title: contentLanguages.Details, dataIndex: 'details', width: '8%' },
    {
      title: contentLanguages.Actions,
      width: '8%',
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <FcViewDetails size={20} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
          {record.isActive ?
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} /> :
            <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
          }
          {(record.type == 'DailyEntry' || record.type == 'Variance') &&
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => openModal(record)} />
          }
        </div>
      ),
    }
  ].filter(Boolean), []);

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  const tableFooter = (
    <div></div>
  )

  return (
    <div>
      {isLoading && <Loader />}

      {!isLoading &&
        <div>
          <div>
            <Row className='g-2 mb-3'>
              <Col md={2}>
                <SearchFilter setFilter={setFilter} />
              </Col>

              <Col md={2}>
                <DatePicker setFilter={setFilter} filter={filter} />
              </Col>

              <Col md={2}>
                <Select
                  styles={selectStyles}
                  options={branchOptions}
                  isSearchable={true}
                  isClearable={true}
                  required
                  placeholder={'Select Branch...'}
                  value={selectedBranch}
                  onChange={(e) => handleSelectChange(e, 'branchId')}
                  isDisabled={!userRole.viewAllBranches}
                />
              </Col>

              <Col md={2}>
                <Select
                  styles={selectStyles}
                  options={allUserOptions}
                  isSearchable={true}
                  isClearable={true}
                  required
                  placeholder={'Select User...'}
                  value={selectedUser}
                  onChange={(e) => handleSelectChange(e, 'createdBy')}
                  isDisabled={!userRole.viewAllUsers}
                />
              </Col>

              <Col md={2}>
                <Select
                  styles={selectStyles}
                  options={TypesData} 
                  isSearchable={true}
                  isClearable={true}
                  isMulti={true}
                  required  
                  placeholder={'Select Types...'}
                  value={selectedTypes} 
                  onChange={handleTypeChange} 
                />
              </Col>

              <Col md={1}>
                <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                  <FiFilter size={15} color='white' />
                </Button>
              </Col>

              <Col md={1} className="d-flex justify-content-end">
                <Button onClick={refreshTableFunction}>
                  <FiPrinter size={18} />
                </Button>
                <Button onClick={refreshTableFunction}>
                  <FiRotateCcw size={18} />
                </Button>
                <Button
                  style={{ backgroundColor: '#23576a', color: 'white' }}
                  onClick={() => openModal()} >Add</Button>
              </Col>
            </Row>

            <SimpleTable
              filter={filter}
              table={table}
              title={title}
              columnDefs={columnDefs}
              idRow={idRow}
              setIdRow={setIdRow}
              refreshTable={refreshTable}
              data={data}
              setData={setData}
              tableFooter={tableFooter}
              api={api}
              getExcelData={getExcelData}
              selection={true}
            />

            <ViewModal
              showModal={showViewModal}
              toggleModal={viewModal}
              journalVoucher={idRow}
            />
          </div>

          {showDeleteModal &&
            <VoidModal
              showModal={showDeleteModal}
              toggleModal={deleteModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, journalVoucher: idRow }}
            />
          }

          {showRecoverModal &&
            <RecoverModal
              showModal={showRecoverModal}
              toggleModal={recoverModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
              data={{ id: idRow?.id, journalVoucher: idRow }}
            />
          }

          {showModal &&
            <JvForm
              showModal={showModal}
              toggleModal={openModal}
              idRow={idRow}
              table={table}
              title={title}
              refreshTable={refreshTableFunction}
              api={api}
            />
          }
        </div>
      }
    </div>
  )
}

export default DailyEntry;